import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SupplierContractReportsIndexTable from './SupplierContractReportsIndexTable';

function SupplierContractReportsIndex(props) {
    return <SupplierContractReportsIndexTable supplierContractReportsIndexUrl={supplierContractReportsIndexUrl} generateUrl={generateUrl} />;
}

export default SupplierContractReportsIndex;
if (document.getElementById('SupplierContractReportsIndex')) {
    var rootEl = document.getElementById('SupplierContractReportsIndex');
    ReactDOM.render(
        <App>
            <SupplierContractReportsIndex />
        </App>,
        rootEl,
    );
}
